import { render } from "./TranslationAlt.vue?vue&type=template&id=20e6142f&ts=true"
import script from "./TranslationAlt.vue?vue&type=script&lang=ts"
export * from "./TranslationAlt.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__